import { useEffect, useState } from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import {
  Box,
  Button,
  Typography,
  TextareaAutosize,
  TextField
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Loading } from '../Loading';

interface RouterPingAndTracerouteProps {
  cpeId: string;
}
export const RouterPingAndTraceroute = ({ cpeId }: RouterPingAndTracerouteProps) => {
  const api = useApi();
  const [result, setResult] = useState<string>('');
  const [ipaddress, setIpaddress] = useState<string>('');
  const [buttonClicked, setButtonClicked] = useState<boolean>(false);

  const {
    isLoading: pingLoading,
    data: pingData,
    refetch: pingRefetch,
    fetchStatus: pingStatus,
    isRefetching: pingRefetching
  } = useQuery(
    ['getPingData'],
    api.runPingApiV1RunPingGet.bind(null, { node_id: cpeId, ip_address: ipaddress}),
    { enabled: false, retry: false, initialData: undefined, onError: apiError },
  );

  const {
    isLoading: tracerouteLoading,
    data: tracerouteData,
    refetch: tracerouteRefetch,
    fetchStatus: tracerouteStatus,
    isRefetching: tracerouteRefetching
  } = useQuery(
      ['getTracerouteData'],
      api.runTracerouteApiV1RunTracerouteGet.bind(null, { node_id: cpeId, ip_address: ipaddress}),
      { enabled: false, retry: false, initialData: undefined, onError: apiError },
  );

  const handlePing = () => {
    setButtonClicked(true);
    pingRefetch();
  }

  const handleTraceroute = () => {
    setButtonClicked(true);
    tracerouteRefetch();
  }

  useEffect(() => {
    if (pingData?.data) {
      const parsedData = (pingData.data as any).result;
      setResult(parsedData);
    }
    setButtonClicked(false);
  }, [pingData]);

  useEffect(() => {
    if (tracerouteData?.data) {
      const parsedData = (tracerouteData.data as any).result;
      setResult(parsedData);
    }
    setButtonClicked(false);
  }, [tracerouteData]);

  const isLoading = pingLoading || tracerouteLoading || pingRefetching || tracerouteRefetching;

  return (
    <Box pt={2}>
      <Typography variant="body1" sx={{ mb: 6 }}>
	      Ping or Traceroute for selected device
      </Typography>
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Input the ip address"
        variant="outlined"
        value={ipaddress}
        onChange={(e) => setIpaddress(e.target.value)}
        autoFocus
      />
      {(isLoading && (pingStatus !== 'idle' || tracerouteStatus !== 'idle')) ? <Loading height={200} /> :
        <TextareaAutosize
          style={{ width: '100%' }}
          minRows={15}
          value={result}
          readOnly
        />
      }
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handlePing} sx={{mr: 5}} disabled={isLoading && buttonClicked}>
          Ping
        </Button>
        <Button variant="outlined" onClick={handleTraceroute} disabled={isLoading && buttonClicked}>
          Traceroute
        </Button>
      </Box>
    </Box>
  );
};
